/* eslint-disable array-callback-return */
import React, { useState, useEffect, useMemo } from "react";
import ProductCard from "../ProductCard";
import { Button, Pagination, Menu, MenuItem, Fade } from "@mui/material"; // Ajout Menu/MenuItem
import "./style.css";
import SortIcon from "@mui/icons-material/Sort"; // Icône plus moderne
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import UseFetch from "../../hook/useFetch";
import { useLocation } from "react-router";
import slugify from "../../Utils/slugify";
export default function AllProducts({
  sousSouscategName,
  souscategName,
  categName,
  familyName,
 onAddToCart 
}) {
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null); // Pour le menu
  const open = Boolean(anchorEl);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const page = parseInt(searchParams.get("page")) || 1;
    setCurrentPage(page);
  }, [location.search]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(6);
  const [sortBy, setSortBy] = useState("newest"); // Changement par défaut
  
  const { data, loading } = UseFetch(
    "https://ebuy-backend-two.vercel.app/api/article"
  );

  const produits = useMemo(() => {
    return Array.from(data).reverse();
  }, [data]);

  // Gestion du Menu
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = (sortValue) => {
    if (sortValue) setSortBy(sortValue);
    setAnchorEl(null);
  };

  // ✅ Gestion responsive du nombre d'articles
  useEffect(() => {
    const updateItemsPerPage = () => {
      const windowWidth = window.innerWidth;
      setItemsPerPage(windowWidth >= 700 ? 15 : 16);
    };
    updateItemsPerPage();
    window.addEventListener("resize", updateItemsPerPage);
    return () => window.removeEventListener("resize", updateItemsPerPage);
  }, []);

const filteredProducts = produits.filter((produit) => {
  const normalize = (v) => slugify(decodeURIComponent(v || ""));

  const urlCategorie = normalize(categName);
  const urlFamille = normalize(familyName);
  const urlSousCategorie = normalize(souscategName);
  const urlSousSousCategorie = normalize(sousSouscategName);

  const produitCategorie = slugify(produit.categorie);
  const produitFamille = slugify(produit.famille);
  const produitSousCategorie = slugify(produit.subcategorie);
  const produitSousSousCategorie = slugify(produit.subSubcategorie);

  return (
    (!urlCategorie || urlCategorie === produitCategorie) &&
    (!urlFamille || urlFamille === produitFamille) &&
    (!urlSousCategorie || urlSousCategorie === produitSousCategorie) &&
    (!urlSousSousCategorie || urlSousSousCategorie === produitSousSousCategorie)
  );
});

  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
  
  // ✅ Tri logique
  const sortedProducts = useMemo(() => {
    let result = [...filteredProducts];
    if (sortBy === "priceAsc") result.sort((a, b) => a.prix - b.prix);
    else if (sortBy === "priceDesc") result.sort((a, b) => b.prix - a.prix);
    // newest: keep original order from filteredProducts
    return result;
  }, [filteredProducts, sortBy]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    window.scrollTo(0, 0);
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("page", newPage.toString());
    window.history.pushState({}, "", `${window.location.pathname}?${searchParams.toString()}`);
  };

  const currentCards = sortedProducts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
console.log("URL:", {
  categName,
  familyName,
  souscategName,
  sousSouscategName
});


  return loading ? (
    <div className="loaderContainer"><div className="loader"></div></div>
  ) : (
    <div>
      <div className="filter-header">
        <Button
          id="sort-button"
          aria-controls={open ? 'sort-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant="text"
          disableElevation
          onClick={handleClick}
          startIcon={<SortIcon />}
          endIcon={<KeyboardArrowDownIcon />}
          className="modern-sort-btn"
        >
          {sortBy === "priceAsc" ? "Prix croissant" : 
           sortBy === "priceDesc" ? "Prix décroissant" : "Nouveautés"}
        </Button>
        <Menu
          id="sort-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={() => handleClose()}
          TransitionComponent={Fade}
          PaperProps={{
            elevation: 0,
            className: "modern-menu-paper"
          }}
        >
          <MenuItem onClick={() => handleClose("newest")} selected={sortBy === "newest"}>Nouveautés</MenuItem>
          <MenuItem onClick={() => handleClose("priceAsc")} selected={sortBy === "priceAsc"}>Prix croissant</MenuItem>
          <MenuItem onClick={() => handleClose("priceDesc")} selected={sortBy === "priceDesc"}>Prix décroissant</MenuItem>
        </Menu>
      </div>

      <div className="allProduct">
        {currentCards.map((produit, index) => (
          <ProductCard
            key={produit._id}
            index={index}
            {...produit} // On passe les props directement
            reference={produit.ref}
            onAddToCart={onAddToCart}
          />
        ))}
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(e, p) => handlePageChange(p)}
            color="warning"
            size="small"
          />
        </div>
      )}
    </div>
  );
}